import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";

import cover from "../assets/img/wi-frame1.webp";
import video from "../assets/vid/wi-video.mp4";
import { Col } from 'react-bootstrap';
import { renderTextBlock } from 'src/components/RenderTextBlocks';
import Video from 'src/components/Video';


export const projectDetails: ProjectInterface = {
    url: "warehouse-invasion",
    title: "Warehouse Invasion",
    summary: "Simple FPS with a few rogue-like elements.",
    description: `This is a FPS game with rogue-like features that I made to practice what I've learned so far from the Unity course: [Create with Code](https://learn.unity.com/pathway/junior-programmer). `,
    year: "2021",
    tags: ["FPS", "Arena", "Roguelike", "Study Project", "Unity"],
    imageSrc: cover,
    hasVideo: true,
    startVideoTime: 0,
    videoSrc: video,
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.PERSONAL,
    roles: ["Game Programmer", "Prototype"],
    technologies: ["Unity", "C#", "WebGL"],
    collaborators: ["Lucas Coutinho"],
    highlightColor: "#60151F",
    descriptionTitle: "Learning Unity… by shooting bugs",
    linkData:
        [
            { type: 'github', url: "https://github.com/lucasctnh/wi-unity-game" },
            { type: 'text', url: "https://play.unity.com/pt/games/441d23e6-6896-4637-a614-fc7a25a0df3e/warehouse-invasion-100" },
        ],
    relatedProjects: ["StreetRacing", "Run01", "CheckMore"],
};


export function WarehouseInvasion() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                titleSize={2.9}
                leftContent={
                    <div className="a-left-no-bg">
                        <Video src={video} />
                    </div>
                }
                rightContent={
                    null
                }>

                <div className='a-body'>
                    <div className="a-body-block">
                        <Col size={12} md={12} className="a-body-left" style={{ marginTop: "0" }}>
                            <div className="a-subtitle">
                                Afterthoughts
                            </div>

                            <div className="a-body-description">
                                {renderTextBlock(`Although this is a finished project I didn't polish it that much and the playtests were far than enough, so there's certainly some bugs yet to find. 😔

Not polishing it wasn't a conscient choice at the beginning, but when I realized that I would have to refactor it I decided not to because I would've spent a lot of time on it. I wanted to keep focusing on learning the basics, the core, and move on to apply this knowledge I gathered into the next projects.

I don't know if it was the correct choice at the time because this certainly led to bugs and performance issues — I have to admit that the code is a mess. 😖

The good thing is that after this project I started to care a lot more about software architecture and planning before coding instead of throwing stuff in and having to refactor everything later.`)}
                            </div>
                        </Col>
                    </div>
                </div>
            </ProjectBase >
        </div >
    );
}